import { PageMessage } from '../../../../types/PageMessage';
import { PortMessage, PortRequestMessage } from '../../../../types/PortMessage';
import { authorizedAxiosInstance } from '../instances/AuthorizedAxiosInstance';

type SortKey = 'NAME';
type SortDirection = 'ASC' | 'DESC';

export interface SortOptions {
    key: SortKey;
    direction: SortDirection;
}

export interface GetPortsParams {
    searchQuery?: string;
    ids?: string[];
    page?: number;
    sortOptions?: SortOptions;
}

export const getPorts = async ({
    searchQuery,
    ids,
    page = 0,
    sortOptions,
}: GetPortsParams): Promise<PageMessage<PortMessage>> => {
    const response = await authorizedAxiosInstance.get(`/v1/port`, {
        params: {
            searchQuery: searchQuery?.trim() || undefined,
            ids: ids?.length ? ids.join(',') : undefined,
            page,
            sortKey: sortOptions?.key,
            sortDirection: sortOptions?.direction,
        },
    });

    return response.data;
};

export const createPort = async (port: PortRequestMessage): Promise<PortMessage> => {
    const response = await authorizedAxiosInstance.post('/v1/port', port);

    return response.data;
};

interface UpdatePortParams {
    id: string;
    port: unknown;
}

export const updatePort = async ({ id, port }: UpdatePortParams): Promise<PortMessage> => {
    const response = await authorizedAxiosInstance.put(`/v1/port/${id}`, port);

    return response.data;
};
